import { DOCUMENT_CONTROL_PANEL_HEIGHT } from 'constants/documents';
import { mediaQuery, MODAL_BODY_DEFAULT_OFFSETS } from 'constants/ui';

const commonWrapperStyles = {
  display: 'flex',
  gap: '24px',
  flexWrap: 'nowrap',
};

export const wrapperStyles = {
  position: 'relative',
  zIndex: 2,
};

export const getContentStyles = isMobile => ({
  ...commonWrapperStyles,
  position: 'relative',
  padding: '12px 24px',
  justifyContent: 'space-between',
  alignItems: isMobile ? 'flex-start' : 'center',
  flexWrap: isMobile ? 'wrap' : 'nowrap',
  gap: isMobile ? '8px' : '24px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  color: ({ palette }) => palette.text.primary,
  zIndex: 3,

  // CSS fallback so the strip always wraps below 768px even if the JS isMobile
  // flag has not yet resolved on first paint (avoids a one-frame nowrap overflow).
  [mediaQuery.mobile]: {
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: '8px',
  },
});

export const expandToggleStyles = {
  flexShrink: 0,
  width: '24px',
  height: '24px',
  padding: 0,
  borderRadius: '4px',
  color: ({ palette }) => palette.text.secondary,
  backgroundColor: 'transparent',

  '&:hover': {
    backgroundColor: 'transparent',
    color: ({ palette }) => palette.text.primary,
  },
};

export const getMainHeaderStyles = (theme, { isInModal } = {}) => {
  const historicalResultsAutocompleteHeight = 78;
  const documentHeight = `calc(100vh - ${
    DOCUMENT_CONTROL_PANEL_HEIGHT + MODAL_BODY_DEFAULT_OFFSETS + historicalResultsAutocompleteHeight
  }px)`;

  return {
    root: {
      height: `calc(100vh - ${historicalResultsAutocompleteHeight}px)`,
      '& .autocomplete-container': {
        maxHeight: historicalResultsAutocompleteHeight,
      },
      '& .document_view__document_pages_wrapper': {
        maxHeight: isInModal ? documentHeight : null,
      },
      '& .document_view__document_slide': {
        minHeight: isInModal ? documentHeight : null,
      },
      [theme.breakpoints.up('md')]: {
        minWidth: 970,
      },
    },
  };
};

export const backdropStyles = {
  zIndex: 1,
};
